"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RowListGroup = exports.ListItemWrapper = exports.LinksWrapper = exports.LinksRow = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _coreListGroup = _interopRequireDefault(require("@vfuk/core-list-group"));
var _coreListItem = _interopRequireDefault(require("@vfuk/core-list-item"));
var _coreMixins = require("@vfuk/core-mixins");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}

/* eslint-disable sonarjs/no-identical-functions */
var LinksWrapper = (0, _styledComponents["default"])(_coreListGroup["default"]).withConfig({
  displayName: "LegalLinksstyle__LinksWrapper",
  componentId: "sc-1tk2t2s-0"
})(function () {
  return (0, _styledComponents.css)(["", ""], (0, _coreMixins.spacing)('margin-bottom', 6));
});
exports.LinksWrapper = LinksWrapper;
var RowListGroup = (0, _styledComponents["default"])(_coreListGroup["default"]).withConfig({
  displayName: "LegalLinksstyle__RowListGroup",
  componentId: "sc-1tk2t2s-1"
})(function () {
  return (0, _styledComponents.css)(["display:flex;"]);
});
exports.RowListGroup = RowListGroup;
var ListItemWrapper = (0, _styledComponents["default"])(_coreListItem["default"]).withConfig({
  displayName: "LegalLinksstyle__ListItemWrapper",
  componentId: "sc-1tk2t2s-2"
})(function () {
  return (0, _styledComponents.css)(["display:flex;"]);
});
exports.ListItemWrapper = ListItemWrapper;
var LinksRow = (0, _styledComponents["default"])(_coreListItem["default"]).withConfig({
  displayName: "LegalLinksstyle__LinksRow",
  componentId: "sc-1tk2t2s-3"
})(function () {
  return (0, _styledComponents.css)(["display:flex;justify-content:center;", " &:first-child{", "}"], (0, _coreMixins.spacing)('margin-top', 2), (0, _coreMixins.spacing)('margin-top', 0));
});
exports.LinksRow = LinksRow;